import React from "react";

/**User context used in navigation, homepage, and job application buttons */
const UserContext = React.createContext();

export default UserContext;